export default __webpack_public_path__ + "static/media/photo7.da1b514e.jpg";